import { callApi, fetchFile } from 'loankeeper-common/api'

export const search = (params) => callApi('linkedfiles_view', { params })

export const details = (body) =>
  fetchFile('linkedfiles_view_file', {
    params: {},
    body,
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const view = ({ ID, hash, LoanID, LoanHash, CollateralID, CollateralHash }) =>
  callApi('linkedfiles_view', {
    params: {
      ClientID: ID,
      HashSum_ClientID_: hash,
      LoanID,
      HashSum_LoanID_: LoanHash,
      CollateralID,
      HashSum_CollateralID_: CollateralHash,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const upload = ({
//   ClientID,
//   HashSum_ClientID_,
//   FileData1,
//   Title,
//   Title_ALT,
//   FileTypeID,
//   AppID,
//   HashSum_AppID_,
//   LoanID,
//   HashSum_LoanID_,
//   CollateralID,
//   HashSum_CollateralID_,
//   PersonalNo,
//   FullName,
// }) => {
//   const data = new FormData()

//   data.append('FileTypeID', FileTypeID)
//   data.append('FileData1', FileData1)
//   data.append('Title', Title)
//   data.append('Title_ALT', Title_ALT)

//   if (ClientID) {
//     data.append('ClientID', ClientID)
//     data.append('HashSum_ClientID_', HashSum_ClientID_)
//   }

//   if (AppID) {
//     data.append('AppID', AppID)
//     data.append('HashSum_AppID_', HashSum_AppID_)
//   }

//   if (LoanID) {
//     data.append('LoanID', LoanID)
//     data.append('HashSum_LoanID_', HashSum_LoanID_)
//   }

//   if (CollateralID) {
//     data.append('CollateralID', CollateralID)
//     data.append('HashSum_CollateralID_', HashSum_CollateralID_)
//   }

//   if (PersonalNo !== undefined) data.append('PersonalNo', PersonalNo)
//   if (FullName !== undefined) data.append('FullName', FullName)

//   console.log(data)
//   return callApi('linkedfiles_upload_file', {
//     method: 'post',
//     body: data,
//   })
// }

// export const edit = ({ action, ...rest }) =>
//   callApi('linkedfiles', {
//     params: { action },
//     method: 'post',
//     body: rest,
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const personalNoCheck = (PersonalNo) => {
  const data = new URLSearchParams({
    PersonalNo,
  })

  return fetch('http://localhost:8890/?action=validateuser', {
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: data,
  })
}

export const signPdf = ({ PersonalNo, PdfFile }) => {
  const data = new URLSearchParams({
    PersonalNo,
    PdfFile,
  })

  return fetch('http://localhost:8890/?action=signPdf', {
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: data,
  })
}

export const urlToFile = async (url, fileName, mimeType) => {
  let res = await fetch(url)

  res = await res.arrayBuffer()

  return await new File([res], fileName, { type: mimeType })
}
